import basketController from './controllers/basket.controller';
import basketItemsController from './controllers/basket.items.controller';
import addButtonController from './controllers/addButton.controller';
import basketIndicatorController from './controllers/basket.indicator.controller';
import expiresAtController from './controllers/expiresAt.controller';
import editReservationDetailsController from './controllers/editReservationDetails.controller';
import reservationItemsController from './controllers/reservationItems.controller';
import membershipBannerController from './controllers/membershipBanner.controller';

import basketComponent from './components/basket.component';
import basketItemsComponent from './components/basket.items.component';
import addButtonComponent from './components/addButton.component';
import basketIndicatorComponent from './components/basket.indicator.component';
import expiresAtComponent from './components/expiresAt.component';
import editReservationDetailsComponent from './components/editReservationDetails.component';
import reservationItemsComponent from './components/reservationItems.component';
import membershipBannerComponent from './components/membershipBanner.component';

import basketApiService from './services/api.basket.service';
import basketItemService from './services/basketItem.service';
import basketService from './services/basket.service';
import apiService from './services/api.service';

let basketModule = angular.module('spabooker.basket', [])
    .controller('basketController', basketController)
    .controller('basketItemsController', basketItemsController)
    .controller('addButtonController', addButtonController)
    .controller('basketIndicatorController', basketIndicatorController)
    .controller('expiresAtController', expiresAtController)
    .controller('editReservationDetailsController', editReservationDetailsController)
    .controller('reservationItemsController', reservationItemsController)
    .controller('membershipBannerController', membershipBannerController)

    .component('basket', basketComponent)
    .component('basketItems', basketItemsComponent)
    .component('addButton', addButtonComponent)
    .component('basketIndicator', basketIndicatorComponent)
    .component('expiresAt', expiresAtComponent)
    .component('editReservationDetails', editReservationDetailsComponent)
    .component('reservationItems', reservationItemsComponent)
    .component('membershipBanner', membershipBannerComponent)

    .factory('basketApiService', basketApiService)
    .factory('basketItemService', basketItemService)
    .factory('basket', basketService)
    .factory('api', apiService)
    ;
export default basketModule.name;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/basket/index.js